// src/services/cloudinaryService.js
const cloudName = "dsysev0vt";
const uploadPreset = "lorelyfotos";

// Las fotos se guardan en original (6000px, 1-2MB). Pedir siempre una versión
// redimensionada: w = ancho máximo en px. f_auto sirve AVIF/WebP si el navegador puede.
export const cld = (url, w) =>
    url?.includes("/image/upload/")
        ? url.replace("/image/upload/", `/image/upload/f_auto,q_auto,c_limit,w_${w}/`)
        : url;

// srcset para que el navegador elija según pantalla y densidad
export const cldSrcSet = (url, widths = [400, 800, 1200]) =>
    widths.map((w) => `${cld(url, w)} ${w}w`).join(", ");

// Comprime en el navegador antes de subir: lado mayor 2560px (el lightbox pide 2000), JPG 85%.
// Si el navegador no puede leerla (p. ej. HEIC en Chrome) se sube el original.
const MAX_LADO = 2560;
export const comprimir = async (file) => {
    if (file.size < 1.5 * 1024 * 1024) return file;
    try {
        const img = await createImageBitmap(file); // respeta la rotación EXIF
        const k = Math.min(1, MAX_LADO / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * k);
        canvas.height = Math.round(img.height * k);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        img.close();
        const blob = await new Promise((ok) => canvas.toBlob(ok, "image/jpeg", 0.85));
        if (!blob || blob.size >= file.size) return file;
        return new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" });
    } catch {
        return file;
    }
};

export const uploadToCloudinary = async (original, folder) => {
    const file = await comprimir(original);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", uploadPreset);
    formData.append("folder", folder);
    formData.append("tags", "sportportfolio");

    try {
        const response = await fetch(
            `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
            {
                method: "POST",
                body: formData
            }
        );
        
        const data = await response.json();
        if (!response.ok) throw new Error(data.error?.message || `HTTP ${response.status}`);
        return {
            success: true,
            url: data.secure_url,
            publicId: data.public_id,
            format: data.format
        };
    } catch (error) {
        console.error("Error subiendo a Cloudinary:", error);
        return { 
            success: false, 
            error: error.message 
        };
    }
};